import {
  setQueryStringParam,
  getQueryStringParams,
  deleteQueryStringParam,
} from "../../shared/utils";

export function triageImprovementsModal({ triageImprovementsUrl }) {
  return {
    open: false,
    loaded: false,
    data: {},
    sort: "squad",
    sortDir: "asc",

    init() {
      const queryParams = getQueryStringParams();
      const improvementsFromParams = queryParams.get("show_improvements");

      if (improvementsFromParams === "true") {
        this.openImprovementsModal();
      }
    },

    openImprovementsModal() {
      this.open = true;
      setQueryStringParam("show_improvements", "true");

      if (!this.loaded) {
        this.fetchImprovementsData();
      }
    },

    clearImprovementsQueryParams() {
      deleteQueryStringParam("show_improvements");
    },

    fetchImprovementsData() {
      fetch(triageImprovementsUrl)
        .then((response) => response.json())
        .then((resp) => {
          this.data = resp;
          this.loaded = true;
        })
        .catch((error) => {
          console.error("Error fetching improvements data:", error);
          this.data = {
            improvements: [],
            num_improvement_areas: 0,
            num_improved_teams: 0,
            num_teams_with_improvement_areas: 0,
          };
          this.loaded = true;
        });
    },

    get improvementAreaSuccessRate() {
      const { improvements, num_improvement_areas } = this.data;
      if (!improvements || !num_improvement_areas) return 0;

      const denominator = Math.max(num_improvement_areas, 1);
      return Math.round((improvements.length / denominator) * 100);
    },

    get sortedImprovements() {
      if (!this.data.improvements) return [];

      let list = [...this.data.improvements];

      // Sort by the selected column
      if (this.sort === "squad") {
        list = list.sort((a, b) => a.squad.localeCompare(b.squad));
      } else if (this.sort === "squad_manager") {
        list = list.sort((a, b) =>
          a.manager.name.localeCompare(b.manager.name),
        );
      } else if (this.sort === "factor") {
        list = list.sort((a, b) => a.factor.localeCompare(b.factor));
      } else if (this.sort === "sentiment") {
        list = list.sort((a, b) => a.sentiment_change - b.sentiment_change);
      } else if (this.sort === "priority") {
        list = list.sort((a, b) => -a.priority_change - -b.priority_change);
      }

      // Reverse if descending
      if (this.sortDir === "desc") {
        list = list.reverse();
      }

      return list;
    },

    changeSort(col) {
      if (this.sort === col) {
        // Toggle sort direction if clicking the same column
        this.sortDir = this.sortDir === "desc" ? "asc" : "desc";
      } else {
        // Set new column and default to desc
        this.sort = col;
        this.sortDir = "desc";
      }
    },
  };
}
